define('views/ProgressBarView',['require','exports','module','views/BaseView','helpers/viewHelpers','ldsh!templates/progress-bar'],function(require, exports, module) {
    "use strict";

    var BaseView = require("views/BaseView");
    var viewHelpers = require("helpers/viewHelpers");

    var View = BaseView.extend({
        template: require("ldsh!templates/progress-bar"),
        initialize: function() {},
        serialize: function() {
            return {
                title: this.title,
                num: this.num,
                max: this.max,
                percent: viewHelpers.getPercent(this.num, this.max)
            };
        }
    });

    module.exports = View;
});

